export default {
  contacted: 1,
  attempted: 6,
  new: 8,
  prospecting: 9,
  appraised: 10,
  listed: 11,
  sold: 12,
  notAttempted: 0,
};
